// src/client/models/ApplicationDocumentTypeEnum.ts
var ApplicationDocumentTypeEnum = /* @__PURE__ */ ((ApplicationDocumentTypeEnum2) => {
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["None"] = 0] = "None";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["Unknown"] = 1] = "Unknown";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ContractWithAgent"] = 10] = "ContractWithAgent";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["PaymentOrder"] = 20] = "PaymentOrder";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ContractWithCounterparty"] = 30] = "ContractWithCounterparty";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["DeliveryDocuments"] = 40] = "DeliveryDocuments";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ServiceAgreement"] = 50] = "ServiceAgreement";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["DocumentsOnExecuting"] = 60] = "DocumentsOnExecuting";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["OtherDocuments"] = 70] = "OtherDocuments";
  ApplicationDocumentTypeEnum2[ApplicationDocumentTypeEnum2["ExchangeAgreement"] = 80] = "ExchangeAgreement";
  return ApplicationDocumentTypeEnum2;
})(ApplicationDocumentTypeEnum || {});

// src/client/models/ConditionKindEnum.ts
var ConditionKindEnum = /* @__PURE__ */ ((ConditionKindEnum2) => {
  ConditionKindEnum2[ConditionKindEnum2["TransferWalletsIndicated"] = 1] = "TransferWalletsIndicated";
  ConditionKindEnum2[ConditionKindEnum2["TransferInFiat"] = 2] = "TransferInFiat";
  ConditionKindEnum2[ConditionKindEnum2["CryptoWalletsFromWhichTransfer"] = 3] = "CryptoWalletsFromWhichTransfer";
  ConditionKindEnum2[ConditionKindEnum2["AmountCryptoSufficient"] = 4] = "AmountCryptoSufficient";
  ConditionKindEnum2[ConditionKindEnum2["ApplicationIsDraft"] = 5] = "ApplicationIsDraft";
  return ConditionKindEnum2;
})(ConditionKindEnum || {});

// src/client/models/ConversationTypeEnum.ts
var ConversationTypeEnum = /* @__PURE__ */ ((ConversationTypeEnum2) => {
  ConversationTypeEnum2[ConversationTypeEnum2["User"] = 10] = "User";
  ConversationTypeEnum2[ConversationTypeEnum2["Ticket"] = 20] = "Ticket";
  return ConversationTypeEnum2;
})(ConversationTypeEnum || {});

// src/client/models/CountryEnum.ts
var CountryEnum = /* @__PURE__ */ ((CountryEnum2) => {
  CountryEnum2[CountryEnum2["None"] = 0] = "None";
  CountryEnum2[CountryEnum2["Russia"] = 1] = "Russia";
  CountryEnum2[CountryEnum2["China"] = 10] = "China";
  CountryEnum2[CountryEnum2["USA"] = 20] = "USA";
  CountryEnum2[CountryEnum2["Italy"] = 30] = "Italy";
  return CountryEnum2;
})(CountryEnum || {});

// src/client/models/CryptoCurrencyEnum.ts
var CryptoCurrencyEnum = /* @__PURE__ */ ((CryptoCurrencyEnum2) => {
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["None"] = 0] = "None";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["ETH"] = 10] = "ETH";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["USDC"] = 20] = "USDC";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["USDT"] = 30] = "USDT";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["BTC"] = 40] = "BTC";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["BNB"] = 50] = "BNB";
  CryptoCurrencyEnum2[CryptoCurrencyEnum2["TON"] = 60] = "TON";
  return CryptoCurrencyEnum2;
})(CryptoCurrencyEnum || {});

// src/client/models/CurrencyTypeEnum.ts
var CurrencyTypeEnum = /* @__PURE__ */ ((CurrencyTypeEnum2) => {
  CurrencyTypeEnum2[CurrencyTypeEnum2["Fiat"] = 10] = "Fiat";
  CurrencyTypeEnum2[CurrencyTypeEnum2["Crypto"] = 20] = "Crypto";
  return CurrencyTypeEnum2;
})(CurrencyTypeEnum || {});

// src/client/models/DefinitionActionKindEnum.ts
var DefinitionActionKindEnum = /* @__PURE__ */ ((DefinitionActionKindEnum2) => {
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Confirm"] = 1e4] = "Confirm";
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Upload"] = 2e4] = "Upload";
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Sign"] = 3e4] = "Sign";
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Reject"] = 4e4] = "Reject";
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Rework"] = 5e4] = "Rework";
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Delete"] = 6e4] = "Delete";
  DefinitionActionKindEnum2[DefinitionActionKindEnum2["Form"] = 7e4] = "Form";
  return DefinitionActionKindEnum2;
})(DefinitionActionKindEnum || {});

// src/client/models/DefinitionActionSubKindEnum.ts
var DefinitionActionSubKindEnum = /* @__PURE__ */ ((DefinitionActionSubKindEnum2) => {
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormEditDraft"] = 10] = "FormEditDraft";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormEditApplication"] = 20] = "FormEditApplication";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormAgentInfo"] = 30] = "FormAgentInfo";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormCounterpartyInfo"] = 40] = "FormCounterpartyInfo";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormExchangeRates"] = 50] = "FormExchangeRates";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormWalletsWhichTransfer"] = 60] = "FormWalletsWhichTransfer";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormProvideWallets"] = 70] = "FormProvideWallets";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormTransferFiat"] = 80] = "FormTransferFiat";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormTransactionId"] = 90] = "FormTransactionId";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["SignExchangeContract"] = 100] = "SignExchangeContract";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["SignExchangeAct"] = 110] = "SignExchangeAct";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["SignTransferContract"] = 120] = "SignTransferContract";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["SignTransferAct"] = 130] = "SignTransferAct";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["UploadClientPaymentDoc"] = 200] = "UploadClientPaymentDoc";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["UploadAdminToProviderDoc"] = 201] = "UploadAdminToProviderDoc";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["UploadTransferCommessionRecepotDoc"] = 202] = "UploadTransferCommessionRecepotDoc";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["UploadTransferRecepotDoc"] = 203] = "UploadTransferRecepotDoc";
  DefinitionActionSubKindEnum2[DefinitionActionSubKindEnum2["FormTransferProvideWallets"] = 700] = "FormTransferProvideWallets";
  return DefinitionActionSubKindEnum2;
})(DefinitionActionSubKindEnum || {});

// src/client/models/DefinitionStepHandlerEnum.ts
var DefinitionStepHandlerEnum = /* @__PURE__ */ ((DefinitionStepHandlerEnum2) => {
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["CRYPTO_PAYMENT_EXPECTATIONS"] = 6] = "CRYPTO_PAYMENT_EXPECTATIONS";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["CONDITION"] = 10] = "CONDITION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["REJECTED"] = 20] = "REJECTED";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["FINISHED"] = 30] = "FINISHED";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_GENERATE_CONTRACT"] = 100] = "EXCHANGE_GENERATE_CONTRACT";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_GENERATE_ACT"] = 110] = "EXCHANGE_GENERATE_ACT";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_CRYPTOWALLET_GENERATION"] = 120] = "EXCHANGE_CRYPTOWALLET_GENERATION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_CRYPTOWALLET_VOLUME"] = 130] = "EXCHANGE_CRYPTOWALLET_VOLUME";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_CRYPTOWALLET_AML"] = 140] = "EXCHANGE_CRYPTOWALLET_AML";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_EXIT_TEST"] = 150] = "EXCHANGE_EXIT_TEST";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_EXIT"] = 160] = "EXCHANGE_EXIT";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_COUNTERPARTY_COMPLIANCE"] = 200] = "TRANSFER_COUNTERPARTY_COMPLIANCE";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_CONTRACT_GENERATION"] = 210] = "TRANSFER_CONTRACT_GENERATION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_ACT_GENERATION"] = 220] = "TRANSFER_ACT_GENERATION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_CRYPTOWALLET_GENERATION"] = 230] = "TRANSFER_CRYPTOWALLET_GENERATION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_CRYPTOWALLET_VOLUME"] = 240] = "TRANSFER_CRYPTOWALLET_VOLUME";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_CRYPTOWALLET_AML"] = 250] = "TRANSFER_CRYPTOWALLET_AML";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_TEST_EXIT"] = 260] = "TRANSFER_TEST_EXIT";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["TRANSFER_EXIT"] = 270] = "TRANSFER_EXIT";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_EXPIRED_CONTRACT_GENERATION"] = 300] = "EXCHANGE_EXPIRED_CONTRACT_GENERATION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_EXPIRED_ACT_GENERATION"] = 310] = "EXCHANGE_EXPIRED_ACT_GENERATION";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_EXPIRED_TEST"] = 320] = "EXCHANGE_EXPIRED_TEST";
  DefinitionStepHandlerEnum2[DefinitionStepHandlerEnum2["EXCHANGE_EXPIRED"] = 330] = "EXCHANGE_EXPIRED";
  return DefinitionStepHandlerEnum2;
})(DefinitionStepHandlerEnum || {});

// src/client/models/DefinitionSubscriptionAggregateKindEnum.ts
var DefinitionSubscriptionAggregateKindEnum = /* @__PURE__ */ ((DefinitionSubscriptionAggregateKindEnum2) => {
  DefinitionSubscriptionAggregateKindEnum2[DefinitionSubscriptionAggregateKindEnum2["Any"] = 10] = "Any";
  DefinitionSubscriptionAggregateKindEnum2[DefinitionSubscriptionAggregateKindEnum2["All"] = 20] = "All";
  return DefinitionSubscriptionAggregateKindEnum2;
})(DefinitionSubscriptionAggregateKindEnum || {});

// src/client/models/DefinitionSubscriptionKindEnum.ts
var DefinitionSubscriptionKindEnum = /* @__PURE__ */ ((DefinitionSubscriptionKindEnum2) => {
  DefinitionSubscriptionKindEnum2[DefinitionSubscriptionKindEnum2["Pending"] = 100] = "Pending";
  DefinitionSubscriptionKindEnum2[DefinitionSubscriptionKindEnum2["Rejected"] = 200] = "Rejected";
  DefinitionSubscriptionKindEnum2[DefinitionSubscriptionKindEnum2["Completed"] = 300] = "Completed";
  return DefinitionSubscriptionKindEnum2;
})(DefinitionSubscriptionKindEnum || {});

// src/client/models/DefinitionTransitionKindEnum.ts
var DefinitionTransitionKindEnum = /* @__PURE__ */ ((DefinitionTransitionKindEnum2) => {
  DefinitionTransitionKindEnum2[DefinitionTransitionKindEnum2["Default"] = 1] = "Default";
  DefinitionTransitionKindEnum2[DefinitionTransitionKindEnum2["Reject"] = 2] = "Reject";
  DefinitionTransitionKindEnum2[DefinitionTransitionKindEnum2["Rework"] = 3] = "Rework";
  DefinitionTransitionKindEnum2[DefinitionTransitionKindEnum2["Yes"] = 4] = "Yes";
  DefinitionTransitionKindEnum2[DefinitionTransitionKindEnum2["No"] = 5] = "No";
  return DefinitionTransitionKindEnum2;
})(DefinitionTransitionKindEnum || {});

// src/client/models/EpochEnum.ts
var EpochEnum = /* @__PURE__ */ ((EpochEnum2) => {
  EpochEnum2[EpochEnum2["All"] = 1] = "All";
  EpochEnum2[EpochEnum2["Draft"] = 2] = "Draft";
  EpochEnum2[EpochEnum2["New"] = 3] = "New";
  EpochEnum2[EpochEnum2["Review"] = 100] = "Review";
  EpochEnum2[EpochEnum2["ReviewAdmin"] = 101] = "ReviewAdmin";
  EpochEnum2[EpochEnum2["ReviewBank"] = 102] = "ReviewBank";
  EpochEnum2[EpochEnum2["ChangesRequired"] = 200] = "ChangesRequired";
  EpochEnum2[EpochEnum2["Confirmed"] = 300] = "Confirmed";
  EpochEnum2[EpochEnum2["ConfirmedAdmin"] = 301] = "ConfirmedAdmin";
  EpochEnum2[EpochEnum2["ExpectConfirmation"] = 302] = "ExpectConfirmation";
  EpochEnum2[EpochEnum2["ExpectingSigning"] = 303] = "ExpectingSigning";
  EpochEnum2[EpochEnum2["ExpectingPayment"] = 304] = "ExpectingPayment";
  EpochEnum2[EpochEnum2["InProgress"] = 400] = "InProgress";
  EpochEnum2[EpochEnum2["ReceiptOfMoney"] = 401] = "ReceiptOfMoney";
  EpochEnum2[EpochEnum2["Completed"] = 500] = "Completed";
  EpochEnum2[EpochEnum2["Accomplished"] = 600] = "Accomplished";
  EpochEnum2[EpochEnum2["Blocked"] = -200] = "Blocked";
  EpochEnum2[EpochEnum2["Refusal"] = -101] = "Refusal";
  EpochEnum2[EpochEnum2["Rejected"] = -100] = "Rejected";
  return EpochEnum2;
})(EpochEnum || {});

// src/client/models/ExchangeRateStatusEnum.ts
var ExchangeRateStatusEnum = /* @__PURE__ */ ((ExchangeRateStatusEnum2) => {
  ExchangeRateStatusEnum2[ExchangeRateStatusEnum2["Active"] = 100] = "Active";
  ExchangeRateStatusEnum2[ExchangeRateStatusEnum2["IsEditedByNotOwner"] = -300] = "IsEditedByNotOwner";
  ExchangeRateStatusEnum2[ExchangeRateStatusEnum2["Removed"] = -200] = "Removed";
  ExchangeRateStatusEnum2[ExchangeRateStatusEnum2["Blocked"] = -100] = "Blocked";
  return ExchangeRateStatusEnum2;
})(ExchangeRateStatusEnum || {});

// src/client/models/ExchangeRateTypeEnum.ts
var ExchangeRateTypeEnum = /* @__PURE__ */ ((ExchangeRateTypeEnum2) => {
  ExchangeRateTypeEnum2[ExchangeRateTypeEnum2["Sell"] = 100] = "Sell";
  ExchangeRateTypeEnum2[ExchangeRateTypeEnum2["Buy"] = 200] = "Buy";
  return ExchangeRateTypeEnum2;
})(ExchangeRateTypeEnum || {});

// src/client/models/GetExchangeRateRangeListQueryOrganizationFilterEnum.ts
var GetExchangeRateRangeListQueryOrganizationFilterEnum = /* @__PURE__ */ ((GetExchangeRateRangeListQueryOrganizationFilterEnum2) => {
  GetExchangeRateRangeListQueryOrganizationFilterEnum2[GetExchangeRateRangeListQueryOrganizationFilterEnum2["OnlyCurrentOrganization"] = 100] = "OnlyCurrentOrganization";
  GetExchangeRateRangeListQueryOrganizationFilterEnum2[GetExchangeRateRangeListQueryOrganizationFilterEnum2["WithoutCurrentOrganization"] = 200] = "WithoutCurrentOrganization";
  return GetExchangeRateRangeListQueryOrganizationFilterEnum2;
})(GetExchangeRateRangeListQueryOrganizationFilterEnum || {});

// src/client/models/NetTypeEnum.ts
var NetTypeEnum = /* @__PURE__ */ ((NetTypeEnum2) => {
  NetTypeEnum2[NetTypeEnum2["None"] = 0] = "None";
  NetTypeEnum2[NetTypeEnum2["ERC20"] = 1] = "ERC20";
  return NetTypeEnum2;
})(NetTypeEnum || {});

// src/client/models/OrganizationDocumentTypeEnum.ts
var OrganizationDocumentTypeEnum = /* @__PURE__ */ ((OrganizationDocumentTypeEnum2) => {
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["Unknown"] = 1] = "Unknown";
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["EGRUL"] = 10] = "EGRUL";
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["Proxy"] = 20] = "Proxy";
  OrganizationDocumentTypeEnum2[OrganizationDocumentTypeEnum2["CharterOfEnterprise"] = 30] = "CharterOfEnterprise";
  return OrganizationDocumentTypeEnum2;
})(OrganizationDocumentTypeEnum || {});

// src/client/models/OrganizationStatusEnum.ts
var OrganizationStatusEnum = /* @__PURE__ */ ((OrganizationStatusEnum2) => {
  OrganizationStatusEnum2[OrganizationStatusEnum2["Awaiting\u0421onfirmation"] = 0] = "Awaiting\u0421onfirmation";
  OrganizationStatusEnum2[OrganizationStatusEnum2["ExpectsChanges"] = 1] = "ExpectsChanges";
  OrganizationStatusEnum2[OrganizationStatusEnum2["Confirmed"] = 10] = "Confirmed";
  OrganizationStatusEnum2[OrganizationStatusEnum2["Blocked"] = -1] = "Blocked";
  return OrganizationStatusEnum2;
})(OrganizationStatusEnum || {});

// src/client/models/ProcessTypeEnum.ts
var ProcessTypeEnum = /* @__PURE__ */ ((ProcessTypeEnum2) => {
  ProcessTypeEnum2[ProcessTypeEnum2["Outgoing"] = 10] = "Outgoing";
  ProcessTypeEnum2[ProcessTypeEnum2["Incoming"] = 20] = "Incoming";
  return ProcessTypeEnum2;
})(ProcessTypeEnum || {});

// src/client/models/RoleEnum.ts
var RoleEnum = /* @__PURE__ */ ((RoleEnum2) => {
  RoleEnum2[RoleEnum2["Provider"] = 10] = "Provider";
  RoleEnum2[RoleEnum2["Client"] = 20] = "Client";
  RoleEnum2[RoleEnum2["Admin"] = 30] = "Admin";
  RoleEnum2[RoleEnum2["Bank"] = 40] = "Bank";
  return RoleEnum2;
})(RoleEnum || {});

// src/client/models/TicketCategoryEnum.ts
var TicketCategoryEnum = /* @__PURE__ */ ((TicketCategoryEnum2) => {
  TicketCategoryEnum2[TicketCategoryEnum2["ProblemWithApplication"] = 10] = "ProblemWithApplication";
  TicketCategoryEnum2[TicketCategoryEnum2["QuestionAboutContract"] = 20] = "QuestionAboutContract";
  TicketCategoryEnum2[TicketCategoryEnum2["TechnicalError"] = 30] = "TechnicalError";
  TicketCategoryEnum2[TicketCategoryEnum2["QuestionAbouDocuments"] = 40] = "QuestionAbouDocuments";
  TicketCategoryEnum2[TicketCategoryEnum2["Other"] = 50] = "Other";
  return TicketCategoryEnum2;
})(TicketCategoryEnum || {});

// src/client/models/TicketStatusEnum.ts
var TicketStatusEnum = /* @__PURE__ */ ((TicketStatusEnum2) => {
  TicketStatusEnum2[TicketStatusEnum2["Open"] = 10] = "Open";
  TicketStatusEnum2[TicketStatusEnum2["InProgress"] = 20] = "InProgress";
  TicketStatusEnum2[TicketStatusEnum2["Closed"] = 30] = "Closed";
  return TicketStatusEnum2;
})(TicketStatusEnum || {});

// src/client/models/UserRoleEnum.ts
var UserRoleEnum = /* @__PURE__ */ ((UserRoleEnum2) => {
  UserRoleEnum2[UserRoleEnum2["Owner"] = 10] = "Owner";
  UserRoleEnum2[UserRoleEnum2["Employee"] = 20] = "Employee";
  return UserRoleEnum2;
})(UserRoleEnum || {});

// src/client/models/UserStatusEnum.ts
var UserStatusEnum = /* @__PURE__ */ ((UserStatusEnum2) => {
  UserStatusEnum2[UserStatusEnum2["Awaiting\u0421onfirmation"] = 0] = "Awaiting\u0421onfirmation";
  UserStatusEnum2[UserStatusEnum2["ExpectsChanges"] = 1] = "ExpectsChanges";
  UserStatusEnum2[UserStatusEnum2["Confirmed"] = 10] = "Confirmed";
  UserStatusEnum2[UserStatusEnum2["Blocked"] = -1] = "Blocked";
  return UserStatusEnum2;
})(UserStatusEnum || {});

// src/shared/core/OpenAPI.ts
var OpenAPI = {
  BASE: "",
  VERSION: "1.0",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: async () => {
    const tokenString = localStorage.getItem("token");
    if (tokenString) {
      const tokenResponse = JSON.parse(tokenString);
      return tokenResponse?.accessToken || "";
    }
    return "";
  }
};

// src/shared/core/ApiError.ts
var ApiError = class extends Error {
  url;
  status;
  statusText;
  body;
  request;
  constructor(request2, response, message) {
    super(message);
    this.name = "ApiError";
    this.url = response.url;
    this.status = response.status;
    this.statusText = response.statusText;
    this.body = response.body;
    this.request = request2;
  }
};

// src/shared/core/CancelablePromise.ts
var CancelError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "CancelError";
  }
  get isCancelled() {
    return true;
  }
};
var CancelablePromise = class {
  #isResolved;
  #isRejected;
  #isCancelled;
  #cancelHandlers;
  #promise;
  #resolve;
  #reject;
  constructor(executor) {
    this.#isResolved = false;
    this.#isRejected = false;
    this.#isCancelled = false;
    this.#cancelHandlers = [];
    this.#promise = new Promise((resolve2, reject) => {
      this.#resolve = resolve2;
      this.#reject = reject;
      const onResolve = (value) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#isResolved = true;
        if (this.#resolve)
          this.#resolve(value);
      };
      const onReject = (reason) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#isRejected = true;
        if (this.#reject)
          this.#reject(reason);
      };
      const onCancel = (cancelHandler) => {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) {
          return;
        }
        this.#cancelHandlers.push(cancelHandler);
      };
      Object.defineProperty(onCancel, "isResolved", {
        get: () => this.#isResolved
      });
      Object.defineProperty(onCancel, "isRejected", {
        get: () => this.#isRejected
      });
      Object.defineProperty(onCancel, "isCancelled", {
        get: () => this.#isCancelled
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  get [Symbol.toStringTag]() {
    return "Cancellable Promise";
  }
  then(onFulfilled, onRejected) {
    return this.#promise.then(onFulfilled, onRejected);
  }
  catch(onRejected) {
    return this.#promise.catch(onRejected);
  }
  finally(onFinally) {
    return this.#promise.finally(onFinally);
  }
  cancel() {
    if (this.#isResolved || this.#isRejected || this.#isCancelled) {
      return;
    }
    this.#isCancelled = true;
    if (this.#cancelHandlers.length) {
      try {
        for (const cancelHandler of this.#cancelHandlers) {
          cancelHandler();
        }
      } catch (error) {
        console.warn("Cancellation threw an error", error);
        return;
      }
    }
    this.#cancelHandlers.length = 0;
    if (this.#reject)
      this.#reject(new CancelError("Request aborted"));
  }
  get isCancelled() {
    return this.#isCancelled;
  }
};

// src/shared/core/request.ts
var isDefined = (value) => {
  return value !== void 0 && value !== null;
};
var isString = (value) => {
  return typeof value === "string";
};
var isStringWithValue = (value) => {
  return isString(value) && value !== "";
};
var isBlob = (value) => {
  return typeof value === "object" && typeof value.type === "string" && typeof value.stream === "function" && typeof value.arrayBuffer === "function" && typeof value.constructor === "function" && typeof value.constructor.name === "string" && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
var isFormData = (value) => {
  return value instanceof FormData;
};
var getQueryString = (params) => {
  const qs = [];
  const append = (key, value) => {
    qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  };
  const process = (key, value) => {
    if (isDefined(value)) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          process(key, v);
        });
      } else if (typeof value === "object") {
        Object.entries(value).forEach(([k, v]) => {
          process(`${key}[${k}]`, v);
        });
      } else {
        append(key, value);
      }
    }
  };
  Object.entries(params).forEach(([key, value]) => {
    process(key, value);
  });
  if (qs.length > 0) {
    return `?${qs.join("&")}`;
  }
  return "";
};
var getUrl = (config, options) => {
  const path = options.url.replace("{api-version}", config.VERSION).replace(/{(.*?)}/g, (substring, group) => {
    if (options.path?.hasOwnProperty(group)) {
      return encodeURI(String(options.path[group]));
    }
    return substring;
  });
  const url = `${config.BASE}${path}`;
  if (options.query) {
    return `${url}${getQueryString(options.query)}`;
  }
  return url;
};
var getFormData = (options) => {
  if (options.formData) {
    const formData = new FormData();
    const process = (key, value) => {
      if (isString(value) || isBlob(value)) {
        formData.append(key, value);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    };
    Object.entries(options.formData).filter(([_, value]) => isDefined(value)).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => process(key, v));
      } else {
        process(key, value);
      }
    });
    return formData;
  }
  return void 0;
};
var resolve = async (options, resolver) => {
  if (typeof resolver === "function") {
    return resolver(options);
  }
  return resolver;
};
var getHeaders = async (config, options) => {
  const token = await resolve(options, config.TOKEN);
  const headers = Object.entries({
    Accept: "application/json",
    ...options.headers
  }).filter(([_, value]) => isDefined(value)).reduce(
    (headers2, [key, value]) => ({
      ...headers2,
      [key]: String(value)
    }),
    {}
  );
  if (isStringWithValue(token)) {
    headers["X-Access-Token"] = `${token}`;
  }
  if (options.body !== void 0) {
    if (options.mediaType) {
      headers["Content-Type"] = options.mediaType;
    } else if (isBlob(options.body)) {
      headers["Content-Type"] = options.body.type || "application/octet-stream";
    } else if (isString(options.body)) {
      headers["Content-Type"] = "text/plain";
    } else if (!isFormData(options.body)) {
      headers["Content-Type"] = "application/json";
    }
  }
  return new Headers(headers);
};
var getRequestBody = (options) => {
  if (options.body !== void 0) {
    if (options.mediaType?.includes("/json")) {
      return JSON.stringify(options.body);
    } else if (isString(options.body) || isBlob(options.body) || isFormData(options.body)) {
      return options.body;
    } else {
      return JSON.stringify(options.body);
    }
  }
  return void 0;
};
var sendRequest = async (config, options, url, body, formData, headers, onCancel) => {
  const controller = new AbortController();
  const request2 = {
    headers,
    body: body ?? formData,
    method: options.method,
    signal: controller.signal
  };
  if (config.WITH_CREDENTIALS) {
    request2.credentials = config.CREDENTIALS;
  }
  onCancel(() => controller.abort());
  return await fetch(url, request2);
};
var getResponseHeader = (response, responseHeader) => {
  if (responseHeader) {
    const content = response.headers.get(responseHeader);
    if (isString(content)) {
      return content;
    }
  }
  return void 0;
};
var getResponseBody = async (response) => {
  if (response.status !== 204) {
    try {
      const contentType = response.headers.get("Content-Type");
      if (contentType) {
        const jsonTypes = ["application/json", "application/problem+json"];
        const binaryTypes = [
          "application/octet-stream",
          "application/pdf",
          "image/",
          "audio/",
          "video/"
        ];
        const isJSON = jsonTypes.some(
          (type) => contentType.toLowerCase().startsWith(type)
        );
        const isBinary = binaryTypes.some(
          (type) => contentType.toLowerCase().startsWith(type)
        );
        if (isJSON) {
          return await response.json();
        } else if (isBinary) {
          return await response.blob();
        } else {
          return await response.text();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  return void 0;
};
var isResponseDataError = (body) => {
  return typeof body === "object" && body !== null && ("errorCode" in body || "isSuccess" in body);
};
var checkResponseDataError = (options, result) => {
  if (result.status === 200 && result.body && isResponseDataError(result.body)) {
    const { errorCode, isSuccess, errorText } = result.body;
    if (isSuccess === false || errorCode !== null && errorCode !== void 0 && errorCode !== 200) {
      const errorStatus = errorCode ?? 500;
      const errorMessage = errorText || "Unknown error";
      return {
        ...result,
        ok: false,
        status: errorStatus,
        statusText: errorMessage
      };
    }
  }
  return null;
};
var catchErrorCodes = (config, options, result) => {
  const dataErrorResult = checkResponseDataError(options, result);
  const finalResult = dataErrorResult || result;
  const errors = {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    ...options.errors
  };
  const error = errors[finalResult.status];
  if (error) {
    const errorText = typeof finalResult.body === "object" && finalResult.body !== null && "errorText" in finalResult.body ? String(finalResult.body.errorText) : error;
    const apiError = new ApiError(options, finalResult, errorText);
    if (config.ON_ERROR && config.ERROR_ROUTES) {
      const errorRoute = config.ERROR_ROUTES[finalResult.status];
      if (errorRoute) {
        config.ON_ERROR(finalResult.status, errorText);
        return;
      }
    }
    throw apiError;
  }
  if (!finalResult.ok) {
    const errorStatus = finalResult.status ?? "unknown";
    const errorStatusText = finalResult.statusText ?? "unknown";
    const errorBody = (() => {
      try {
        return JSON.stringify(finalResult.body, null, 2);
      } catch (e) {
        return void 0;
      }
    })();
    const errorMessage = `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`;
    const apiError = new ApiError(options, finalResult, errorMessage);
    if (config.ON_ERROR && config.ERROR_ROUTES && typeof errorStatus === "number") {
      const errorRoute = config.ERROR_ROUTES[errorStatus];
      if (errorRoute) {
        config.ON_ERROR(errorStatus, errorMessage);
        return;
      }
    }
    throw apiError;
  }
};
var request = (config, options) => {
  return new CancelablePromise(async (resolve2, reject, onCancel) => {
    try {
      const url = getUrl(config, options);
      const formData = getFormData(options);
      const body = getRequestBody(options);
      const headers = await getHeaders(config, options);
      if (!onCancel.isCancelled) {
        const response = await sendRequest(
          config,
          options,
          url,
          body,
          formData,
          headers,
          onCancel
        );
        const responseBody = await getResponseBody(response);
        const responseHeader = getResponseHeader(
          response,
          options.responseHeader
        );
        const result = {
          url,
          ok: response.ok,
          status: response.status,
          statusText: response.statusText,
          body: responseHeader ?? responseBody
        };
        catchErrorCodes(config, options, result);
        resolve2(result.body);
      }
    } catch (error) {
      reject(error);
    }
  });
};

// src/client/services/ActionService.ts
var ActionService = class {
  /**
   * Список действий
   * @returns ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum OK
   * @throws ApiError
   */
  static getApiV1ActionList() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/action/list"
    });
  }
  /**
   * Получить документ для действия
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1ActionDocument({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/action/{id}/document",
      path: {
        "id": id
      }
    });
  }
  /**
   * Действие подтвердить
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionConfirm({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/confirm",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Действие загрузить документ
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionUpload({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/upload",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Действие загрузить подпись
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionSign({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/sign",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Действие отклонить
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionReject({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/reject",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Действие переделать
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionRework({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/rework",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Действие удалить
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionDelete({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/delete",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Форма информации об агенте
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormAgentInfo({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/agentInfo",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Форма обменных курсов
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormExchangeRates({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/exchangeRates",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Форма редактирования черновика
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormEditDraft({
    id,
    sign,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/editDraft",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Форма редактирования заявки
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormEditApplication({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/editApplication",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Форма информации о контрагенте
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormCounterpartyInfo({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/counterpartyInfo",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Форма кошельков, с которых будет осуществлять перевод ПЛ
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormProvideWallets({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/provideWallets",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Форма кошельков, с которых будет осуществлять перевод контрагент
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormWalletsWhichTransfer({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/walletsWhichTransfer",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Форма ввода суммы перевода фиата
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormTransferFiat({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/transferFiat",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Форма ввода мдентификатора транзакции
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1ActionFormTransactionId({
    id,
    sign,
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/action/{id}/form/transactionId",
      path: {
        "id": id
      },
      headers: {
        "sign": sign
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
};

// src/client/services/ApplicationService.ts
var ApplicationService = class {
  /**
   * Создать зявку
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static postApiV1ApplicationCreate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/application/create",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить заявку по идентификатору
   * @returns ResponseData_ApplicationResponse OK
   * @throws ApiError
   */
  static getApiV1Application({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}",
      path: {
        id
      }
    });
  }
  /**
   * Получить информацию о клиенте заявки
   * @returns ResponseData_ApplicationParticipantsResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationParticipants({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/participants",
      path: {
        id
      }
    });
  }
  /**
   * Получить информацию о контракте заявки
   * @returns ResponseData_ApplicationContractResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationContract({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/contract",
      path: {
        id
      }
    });
  }
  /**
   * Получить информацию о контракте с агентом
   * @returns ResponseData_ApplicationAgentContractResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationAgentContract({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/agentContract",
      path: {
        id
      }
    });
  }
  /**
   * Получить историю заявки по идентификатору
   * @returns ResponseData_Array_ApplicationHistoryResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationHistory({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/history",
      path: {
        id
      }
    });
  }
  /**
   * Получить комментарии заявки по идентификатору
   * @returns ResponseData_Array_ApplicationCommentResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationComments({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/comments",
      path: {
        id
      }
    });
  }
  /**
   * Получить комиссии заявки по идентификатору
   * @returns ResponseData_ApplicationFeeResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationFee({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/fee",
      path: {
        id
      }
    });
  }
  /**
   * Получить список заявок
   * @returns ResponseData_PagedResponse_ApplicationListResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationList({
    epochId,
    currencyId,
    processTypeId,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/list",
      query: {
        epochId,
        currencyId,
        processTypeId,
        dateFrom,
        dateTo,
        pageNumber,
        pageSize
      }
    });
  }
  /**
   * Получить документы всех заявок
   * @returns ResponseData_PagedResponse_AllApplicationsDocumentResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationDocument({
    documentTypeIds,
    dateFrom,
    dateTo,
    search,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/document",
      query: {
        documentTypeIds,
        dateFrom,
        dateTo,
        search,
        pageNumber,
        pageSize
      }
    });
  }
  /**
   * Получить документы заявки
   * @returns ResponseData_Array_ApplicationDocumentResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationDocument1({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/document",
      path: {
        id
      }
    });
  }
  /**
   * Получить документ заявки по идентификатору
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1ApplicationDocument2({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/document/{id}",
      path: {
        id
      }
    });
  }
  /**
   * Получить подпись по идентификатору
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1ApplicationDocumentSign({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/document/sign/{id}",
      path: {
        id
      }
    });
  }
  /**
   * Получить список эпох
   * @returns ResponseData_List_ApplicationEpochListResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationEpochs() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/epochs"
    });
  }
  /**
   * Получить список поставщиков ликвидности
   * @returns ResponseData_Array_ApplicationExchangeRateResponse OK
   * @throws ApiError
   */
  static getApiV1ApplicationExchangeOffers({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/application/{id}/exchangeOffers",
      path: {
        id
      }
    });
  }
};

// src/client/services/AuthorizeService.ts
var AuthorizeService = class {
  /**
   * Получить секретный ключ для авторизации по ЭЦП.
   * @returns ResponseData_AuthSecretResponse OK
   * @throws ApiError
   */
  static postApiV1AuthorizeSecret({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/authorize/secret",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить JWT токен
   * @returns ResponseData_AuthTokenResponse OK
   * @throws ApiError
   */
  static postApiV1AuthorizeToken({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/authorize/token",
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/client/services/CurrencyService.ts
var CurrencyService = class {
  /**
   * Получить список валют
   * @returns ResponseData_PagedResponse_GetCurrencyResponse OK
   * @throws ApiError
   */
  static getApiV1Currency({
    search,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/currency",
      query: {
        "search": search,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Добавить валюту
   * @returns ResponseData_Int32 OK
   * @throws ApiError
   */
  static postApiV1CurrencyCreate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/currency/create",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить валюту
   * @returns any OK
   * @throws ApiError
   */
  static putApiV1CurrencyUpdate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/currency/update",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить статус
   * @returns any OK
   * @throws ApiError
   */
  static putApiV1CurrencySetStatus({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/currency/setStatus",
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/client/services/DictionariesService.ts
var DictionariesService = class {
  /**
   * Получить список стран
   * @returns ResponseData_Array_DictionaryEnumResponse_CountryEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesCountries() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/countries"
    });
  }
  /**
   * Получить список валют
   * @returns ResponseData_Array_CurrencyDictionaryResponse_Int32 OK
   * @throws ApiError
   */
  static getApiV1DictionariesCurrencies() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/currencies"
    });
  }
  /**
   * Получить список криптовалют
   * @returns ResponseData_Array_CurrencyDictionaryResponse_CryptoCurrencyEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesCryptoCurrencies() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/cryptoCurrencies"
    });
  }
  /**
   * Получить список типов заявок
   * @returns ResponseData_Array_DictionaryEnumResponse_ProcessTypeEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesProcessTypes() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/processTypes"
    });
  }
  /**
   * Получить список ролей
   * @returns ResponseData_Array_DictionaryEnumResponse_RoleEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesRoles() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/roles"
    });
  }
  /**
   * Получить список действий
   * @returns ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesActions() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/actions"
    });
  }
  /**
   * Получить список эпох
   * @returns ResponseData_Array_DictionaryEnumResponse_EpochEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesEpochs() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/epochs"
    });
  }
  /**
   * Получить список сетей
   * @returns ResponseData_CryptoNetDictionaryResponse OK
   * @throws ApiError
   */
  static getApiV1DictionariesNets() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/nets"
    });
  }
  /**
   * Получить список типов документов для заявки
   * @returns ResponseData_Array_DictionaryEnumResponse_ApplicationDocumentTypeEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesApplicationDocumentTypes() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/applicationDocumentTypes"
    });
  }
  /**
   * Получить список типов документов организации
   * @returns ResponseData_Array_DictionaryEnumResponse_OrganizationDocumentTypeEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesOrganizationDocumentTypes() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/organizationDocumentTypes"
    });
  }
  /**
   * Получить список категорий обращения
   * @returns ResponseData_Array_DictionaryEnumResponse_TicketCategoryEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesTicketCategories() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/ticketCategories"
    });
  }
  /**
   * Получить список статусов обращения
   * @returns ResponseData_Array_DictionaryEnumResponse_TicketStatusEnum OK
   * @throws ApiError
   */
  static getApiV1DictionariesTicketStatuses() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/dictionaries/ticketStatuses"
    });
  }
};

// src/client/services/ExchanegeRateService.ts
var ExchanegeRateService = class {
  /**
   * Получить список поставщиков
   * @returns ResponseData_Array_ExchangeRate2Response OK
   * @throws ApiError
   */
  static getApiV1ExchanegeRateProviders({
    applicationId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/exchanegeRate/providers",
      query: {
        "applicationId": applicationId
      }
    });
  }
  /**
   * Получить рекомендованные курсы
   * @returns ResponseData_PagedResponse_RecommendedRateResponse OK
   * @throws ApiError
   */
  static getApiV1ExchanegeRateRecommended({
    cryptoCurrencies,
    currencies,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/exchanegeRate/recommended",
      query: {
        "cryptoCurrencies": cryptoCurrencies,
        "currencies": currencies,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить курсы
   * @returns ResponseData_PagedResponse_ExchangeRateRangeListResponse OK
   * @throws ApiError
   */
  static getApiV1ExchanegeRateList({
    search,
    type,
    cryptoCurrencies,
    currencies,
    amountMin,
    amountMax,
    organziationFilter,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/exchanegeRate/list",
      query: {
        "search": search,
        "type": type,
        "cryptoCurrencies": cryptoCurrencies,
        "currencies": currencies,
        "amountMin": amountMin,
        "amountMax": amountMax,
        "organziationFilter": organziationFilter,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить курс
   * @returns ResponseData_ExchangeRateResponse OK
   * @throws ApiError
   */
  static getApiV1ExchanegeRate({
    rateId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/exchanegeRate",
      query: {
        "rateId": rateId
      }
    });
  }
  /**
   * Получить историю курса
   * @returns ResponseData_Array_ExchangeRateHistroryResponse OK
   * @throws ApiError
   */
  static getApiV1ExchanegeRateHistory({
    rateId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/exchanegeRate/history",
      query: {
        "rateId": rateId
      }
    });
  }
  /**
   * Создать курс
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static postApiV1ExchanegeRateCreate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/exchanegeRate/create",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Продлить курс
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static putApiV1ExchanegeRateExtend({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/exchanegeRate/extend",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Удалить курсы
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static deleteApiV1ExchanegeRateRemove({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/exchanegeRate/remove",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить курс
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static putApiV1ExchanegeRateUpdateProvider({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/exchanegeRate/update/provider",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Добавить рекомендованный курс
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static postApiV1ExchanegeRateRecommendedCreate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/exchanegeRate/recommended/create",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить рекомендованный курс
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static postApiV1ExchanegeRateRecommendedUpdate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/exchanegeRate/recommended/update",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Заблокировать курс
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static putApiV1ExchanegeRateBlock({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/exchanegeRate/block",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить
   * @returns ResponseData_Guid OK
   * @throws ApiError
   */
  static putApiV1ExchanegeRateUpdateAdmin({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/exchanegeRate/update/admin",
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/client/services/NotificationService.ts
var NotificationService = class {
  /**
   * Получить уведомления
   * @returns ResponseData_PagedResponse_NotificationResponse OK
   * @throws ApiError
   */
  static getApiV1NotificationNotification({
    isRead,
    startAt,
    endAt,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/notification/notification",
      query: {
        "isRead": isRead,
        "startAt": startAt,
        "endAt": endAt,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить кол-во непрочитанных уведомлений
   * @returns ResponseData_Int32 OK
   * @throws ApiError
   */
  static getApiV1NotificationNotificationUnreadCount() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/notification/notification/unreadCount"
    });
  }
  /**
   * Прочитать уведомления
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1NotificationNotificationRead({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/notification/notification/read",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Отправить уведомление
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1NotificationNotificationSend({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/notification/notification/send",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * SignalR Notification Hub — инструкция по использованию.
   *
   * Клиентам необходимо подключаться к SignalR-хабу по адресу:
   * `https://your-server.com/notificationHub`
   *
   * После установления соединения клиент должен в течение 5 сек вызвать метод:
   * ```
   * connection.invoke("AuthorizeConnection", token);
   *
   * ```
   * где `token` — пользовательский access token, выданный вашим API.
   * По истечении указанного временного интервала соединение будет разорвано.
   *
   *
   * После авторизации сервер может вызывать следующие методы на клиенте:<list type="bullet">
   * <item><description><b>ReceiveNotification(notification)</b> — получение уведомления.</description></item>
   * <item><description><b>ForceDisconnect(reason)</b> — сервер принудительно завершает соединение.</description></item></list>
   *
   * Рекомендуется на стороне клиента использовать SignalR с автоматическим переподключением:
   *
   * Пример клиента на TypeScript:
   *
   *
   * const connection = new signalR.HubConnectionBuilder()
   * .withUrl("https://your-server.com/notificationHub", {
       * transport: signalR.HttpTransportType.WebSockets,
       * skipNegotiation: true
       * })
       * .withAutomaticReconnect()
       * .build();
       *
       * await connection.start();
       * await connection.invoke("AuthorizeConnection", token);
       *
       * connection.on("ReceiveNotification", n => console.log("Notification:", n));
       * connection.on("ForceDisconnect", msg => connection.stop());
       *
       *
       * Подключение можно закрыть вызовом:```await connection.stop();```
       *
       * Этот эндпоинт не выполняет действий, служит только как документация для Swagger.
       * @returns any Описание успешно возвращено
       * @throws ApiError
       */
  static getApiV1NotificationHubInfo() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/notification/hub-info"
    });
  }
};

// src/client/services/OrganizationService.ts
var OrganizationService = class {
  /**
   * Получить данные организации
   * @returns ResponseData_OrganizationResponse OK
   * @throws ApiError
   */
  static getApiV1Organization() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/organization"
    });
  }
  /**
   * Обновить данные организации
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiV1Organization({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/organization",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Скачать документ
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1OrganizationFiles({
    fileId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/organization/files/{fileId}",
      path: {
        "fileId": fileId
      }
    });
  }
  /**
   * Получить список документов организации
   * @returns ResponseData_Array_OrganizationDocumentResponse OK
   * @throws ApiError
   */
  static getApiV1OrganizationFiles1({
    documentTypeIds,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/organization/files",
      query: {
        "documentTypeIds": documentTypeIds,
        "dateFrom": dateFrom,
        "dateTo": dateTo,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Загрузить документы
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1OrganizationFilesUpload({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/organization/files/upload",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Заменить файл
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiV1OrganizationFilesReplace({
    fileId,
    formData
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/organization/files/{fileId}/replace",
      path: {
        "fileId": fileId
      },
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Переименовать файл
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiV1OrganizationFilesRename({
    fileId,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/organization/files/{fileId}/rename",
      path: {
        "fileId": fileId
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Изменить тип файла
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiV1OrganizationFilesSetDocumentType({
    fileId,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/organization/files/{fileId}/setDocumentType",
      path: {
        "fileId": fileId
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/client/services/PipelineService.ts
var PipelineService = class {
  /**
   * Получить pipeline в виде html документа
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1Pipeline({
    processTypeId
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/pipeline/{processTypeId}",
      path: {
        "processTypeId": processTypeId
      }
    });
  }
  /**
   * Получить первый pipeline в виде html документа
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1PipelineFirst() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/pipeline/first"
    });
  }
  /**
   * @returns string OK
   * @throws ApiError
   */
  static getApiV1PipelineQuery() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/pipeline/query"
    });
  }
};

// src/client/services/ProcessService.ts
var ProcessService = class {
  /**
   * @returns Process OK
   * @throws ApiError
   */
  static getApiV1ProcessDefinitionProcess({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/process/definition/process/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * @returns ResponseData_List_DefinitionProcess OK
   * @throws ApiError
   */
  static getApiV1ProcessDefinitionProcesses() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/process/definition/processes"
    });
  }
};

// src/client/services/SessionService.ts
var SessionService = class {
  /**
   * Получить список сессий
   * @returns ResponseData_SessionResponse OK
   * @throws ApiError
   */
  static getApiV1SessionList() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/session/list"
    });
  }
  /**
   * Удалить сессию по идентификатору
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static deleteApiV1Session({
    id
  }) {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/session/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Удалить все сессии
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static deleteApiV1Session1() {
    return request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/session"
    });
  }
};

// src/client/services/SupportService.ts
var SupportService = class {
  /**
   * Получить обращение
   * @returns ResponseData_TicketResponse OK
   * @throws ApiError
   */
  static getApiV1SupportTicket({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/ticket/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить список обращений
   * @returns ResponseData_PagedResponse_TicketResponse OK
   * @throws ApiError
   */
  static getApiV1SupportTicketList({
    statusId,
    categoryId,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/ticket/list",
      query: {
        "statusId": statusId,
        "categoryId": categoryId,
        "dateFrom": dateFrom,
        "dateTo": dateTo,
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить сообщения обращения
   * @returns ResponseData_PagedResponse_MessageResponse OK
   * @throws ApiError
   */
  static getApiV1SupportTicketMessage({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/ticket/{id}/message",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить список сообщений личного чата
   * @returns ResponseData_PagedResponse_MessageResponse OK
   * @throws ApiError
   */
  static getApiV1SupportMessageList({
    pageNumber,
    pageSize
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/message/list",
      query: {
        "pageNumber": pageNumber,
        "pageSize": pageSize
      }
    });
  }
  /**
   * Получить сообщение
   * @returns ResponseData_MessageResponse OK
   * @throws ApiError
   */
  static getApiV1SupportMessage({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/message/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить вложение к сообщению
   * @returns binary OK
   * @throws ApiError
   */
  static getApiV1SupportMessageAttachment({
    id
  }) {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/message/attachment/{id}",
      path: {
        "id": id
      }
    });
  }
  /**
   * Получить список FAQ
   * @returns ResponseData_Array_FaqResponse OK
   * @throws ApiError
   */
  static getApiV1SupportFaqList() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/faq/list"
    });
  }
  /**
   * Создание обращения
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1SupportTicketCreate({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/support/ticket/create",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Переоткрыть обращение
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1SupportTicketReopen({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/support/ticket/reopen",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Прочитать сообщения
   * @returns ResponseData_Int32 OK
   * @throws ApiError
   */
  static postApiV1SupportMessageRead({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/support/message/read",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Отправить сообщение
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1SupportMessageSend({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/support/message/send",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * Отправить сообщение для обращения
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1SupportTicketMessageSend({
    formData
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/support/ticket/message/send",
      formData,
      mediaType: "multipart/form-data"
    });
  }
  /**
   * SignalR Message Hub — инструкция по использованию.
   *
   * Клиентам необходимо подключаться к SignalR-хабу по адресу:
   * `https://your-server.com/messageHub`
   *
   * После установления соединения клиент должен в течение 5 сек вызвать метод:
   * ```
   * connection.invoke("AuthorizeConnection", token);
   *
   * ```
   * где `token` — пользовательский access token, выданный вашим API.
   * По истечении указанного временного интервала соединение будет разорвано.
   *
   *
   * После авторизации сервер может вызывать следующие методы на клиенте:<list type="bullet">
   * <item><description><b>ReceiveMessage(message)</b> — получение сообщения.</description></item>
   * <item><description><b>ForceDisconnect(reason)</b> — сервер принудительно завершает соединение.</description></item></list>
   *
   * Рекомендуется на стороне клиента использовать SignalR с автоматическим переподключением:
   *
   * Пример клиента на TypeScript:
   *
   *
   * const connection = new signalR.HubConnectionBuilder()
   * .withUrl("https://your-server.com/messageHub", {
       * transport: signalR.HttpTransportType.WebSockets,
       * skipNegotiation: true
       * })
       * .withAutomaticReconnect()
       * .build();
       *
       * await connection.start();
       * await connection.invoke("AuthorizeConnection", token);
       *
       * connection.on("ReceiveMessage", n => console.log("Message:", n));
       * connection.on("ForceDisconnect", msg => connection.stop());
       *
       *
       * Подключение можно закрыть вызовом:```await connection.stop();```
       *
       * Этот эндпоинт не выполняет действий, служит только как документация для Swagger.
       * @returns any Описание успешно возвращено
       * @throws ApiError
       */
  static getApiV1SupportHubInfo() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/support/hub-info"
    });
  }
};

// src/client/services/UserService.ts
var UserService = class {
  /**
   * Получить информацию о пользователе
   * @returns ResponseData_UserResponse OK
   * @throws ApiError
   */
  static getApiV1User() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/v1/user"
    });
  }
  /**
   * Обновить данные пользователя
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiV1User({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/user",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить информацию о сертификатах
   * @returns ResponseData_Array_UserCertificateResponse OK
   * @throws ApiError
   */
  static postApiV1UserCertificates() {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/user/certificates"
    });
  }
  /**
   * Добавить сертификат
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiV1UserCertificate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/v1/user/certificate",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Обновить данные 2FA
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiV1UserTwoFactor({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/user/twoFactor",
      body: requestBody,
      mediaType: "application/json"
    });
  }
};

// src/admin/services/UserService.ts
var UserService2 = class {
  /**
   * Получить информацию о пользователе
   * @returns ResponseData_UserResponse OK
   * @throws ApiError
   */
  static getApiAdminV1User() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/user"
    });
  }
  /**
   * Обновить данные пользователя
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1User({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить информацию о сертификате
   * @returns ResponseData_Array_UserCertificateResponse OK
   * @throws ApiError
   */
  static postApiAdminV1UserCertificates() {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/user/certificates"
    });
  }
  /**
   * Добавить сертификат
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static postApiAdminV1UserCertificate({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "POST",
      url: "/api/admin/v1/user/certificate",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Обновить данные 2FA
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1UserTwoFactor({
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user/twoFactor",
      body: requestBody,
      mediaType: "application/json"
    });
  }
  /**
   * Получить пользователей ожидающие подтверждения
   * @returns ResponseData_Array_ActivationPendingUserResponse OK
   * @throws ApiError
   */
  static getApiAdminV1UserPending() {
    return request(OpenAPI, {
      method: "GET",
      url: "/api/admin/v1/user/pending"
    });
  }
  /**
   * Активировать пользователя
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1UserActivate({
    id
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user/{id}/activate",
      path: {
        "id": id
      }
    });
  }
  /**
   * Нужны правки по пользователю
   * @returns ResponseData_Boolean OK
   * @throws ApiError
   */
  static putApiAdminV1UserRework({
    id,
    requestBody
  }) {
    return request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/v1/user/{id}/rework",
      path: {
        "id": id
      },
      body: requestBody,
      mediaType: "application/json"
    });
  }
};
export {
  ActionService,
  UserService2 as AdminUserService,
  ApplicationDocumentTypeEnum,
  ApplicationService,
  AuthorizeService,
  UserService as ClientUserService,
  ConditionKindEnum,
  ConversationTypeEnum,
  CountryEnum,
  CryptoCurrencyEnum,
  CurrencyService,
  CurrencyTypeEnum,
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum,
  DefinitionStepHandlerEnum,
  DefinitionSubscriptionAggregateKindEnum,
  DefinitionSubscriptionKindEnum,
  DefinitionTransitionKindEnum,
  DictionariesService,
  EpochEnum,
  ExchanegeRateService,
  ExchangeRateStatusEnum,
  ExchangeRateTypeEnum,
  GetExchangeRateRangeListQueryOrganizationFilterEnum,
  NetTypeEnum,
  NotificationService,
  OpenAPI,
  OrganizationDocumentTypeEnum,
  OrganizationService,
  OrganizationStatusEnum,
  PipelineService,
  ProcessService,
  ProcessTypeEnum,
  RoleEnum,
  SessionService,
  SupportService,
  TicketCategoryEnum,
  TicketStatusEnum,
  UserRoleEnum,
  UserService,
  UserStatusEnum
};
//# sourceMappingURL=index.js.map